import React from 'react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-surface py-12">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-lg font-semibold tracking-tight text-ink">TimeStat</h2>
            <p className="mt-2 text-sm text-ink-2">
              Attendance tracking for construction teams.
            </p>
          </div>

          <ul className="flex flex-wrap gap-x-6 gap-y-3 text-sm text-ink-2">
            <li><a href="/privacyPolicy" className="transition hover:text-ink">Privacy Policy</a></li>
            <li><a href={`mailto:info@megasoftwaresolutions.com?body=From web App`} className="transition hover:text-ink">Contact</a></li>
            <li><a href="/careers" className="transition hover:text-ink">Careers</a></li>
            <li><a href="/terms-of-service" className="transition hover:text-ink">Terms</a></li>
          </ul>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-border pt-6 md:flex-row md:items-center md:justify-between">
          <p className="text-xs text-ink-3">&copy; {currentYear} TimeStat. All rights reserved.</p>
          <ul className="flex gap-4">
            <li>
              <a href="https://www.facebook.com/profile.php?id=100087348553796" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-ink-3 transition hover:text-ink">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22.675 0h-21.35C.596 0 0 .596 0 1.326v21.348C0 23.405.596 24 1.326 24H12.82v-9.294H9.692V11.3h3.128V8.412c0-3.1 1.892-4.786 4.656-4.786 1.325 0 2.464.099 2.795.143v3.241l-1.917.001c-1.504 0-1.795.715-1.795 1.76V11.3h3.588l-.467 3.406h-3.121V24h6.116c.73 0 1.326-.595 1.326-1.326V1.326C24 .596 23.405 0 22.675 0z" />
                </svg>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-ink-3 transition hover:text-ink">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452H17.25v-5.571c0-1.328-.025-3.037-1.851-3.037-1.852 0-2.135 1.447-2.135 2.944v5.664H9.118v-11.44h3.099v1.562h.044c.431-.821 1.48-1.687 3.047-1.687 3.259 0 3.86 2.146 3.86 4.938v6.627zM5.337 8.433a1.796 1.796 0 1 1 0-3.591 1.796 1.796 0 0 1 0 3.591zM6.958 20.452H3.714V8.963h3.244v11.489zm17.042-15.452C24 2.69 23.31 2 22.453 2H1.548C.69 2 0 2.69 0 3.548v16.904C0 21.31.69 22 1.548 22h20.905c.857 0 1.547-.69 1.547-1.548V3.548z" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
